import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLaptopMedical } from '@fortawesome/free-solid-svg-icons';
import { renderFilter } from '../../../Shared/TextHelpers';

function PracticePims({ pims, filter }) {
    return (
        <>
            <FontAwesomeIcon icon={faLaptopMedical} />
            &emsp;
            {renderFilter(pims, filter)}
        </>
    );
}

export default PracticePims;
